// full library entry point.
// 6.11.4

module.exports = require("./src/index");
